export default {
  columns: {
    offerName: 'Tarjouksen nimi',
    type: 'Tyyppi',
    status: 'Tila',
    active: 'Aktiivinen',
    inactive: 'Ei aktiivinen',
    details: 'Tiedot',
    schedule: 'Aikataulu',
    startDate: 'Aloituspäivä',
    images: 'Kuva',
  },
  actions: {
    edit: 'Muokkaa',
    rename: 'Nimeä uudelleen',
    delete: 'Poista',
    set_active: 'Aseta aktiiviseksi',
    set_inactive: 'Aseta ei-aktiiviseksi',
    cancel: 'Peruuta',
    confirm: 'Vahvista',
    activate: 'Korvaa ja aktivoi',
    manage_images: 'Muokkaa kuvaa',
  },
  toasts: {
    offer_enabled: '{{offer}} on nyt aktiivinen tarjous kohteelle {{for}}',
    offer_disabled: '{{offer}} asetettu ei-aktiiviseksi.',
    update_failed: 'Tarjouksen päivitys epäonnistui.',
    successfully_deleted: 'Tarjous poistettiin onnistuneesti',
    delete_failed: 'Tarjouksen poistaminen epäonnistui',
  },
  title: 'Hallitse kaikkia tarjouksia',
  popups: {
    delete: {
      title: 'Haluatko varmasti poistaa tämän tarjouksen?',
    },
    toggle: {
      title_overlapping_is_not_allowed: 'Pääasiallisten tarjousten korvaaminen ei ole sallittua',
      title: 'Korvataanko aktiivinen tarjous tälle ajanjaksolle?',
      description:
        'Aktivoit tarjouksen {{offer}} päivänä {{weekday}}{{between}}. Tämä poistaa käytöstä nykyisen aktiivisen tarjouksen {{currentOffer}} samalle ajanjaksolle.',
      between: ', välillä {{start}}-{{end}}',
    },
  },
};
